import { SizableText, YStack, YStackProps, colors, shadowStandard, styled } from '@my/ui'
import { Frown, Smile } from '@tamagui/lucide-icons'

const iconMap = {
  frown: Frown,
  smile: Smile,
}
export interface NoResultsProps {
  text: string
  caption: string
  icon?: keyof typeof iconMap
  size?: 'sm' | 'lg'
}

const NoResultsText = styled(SizableText, {
  textAlign: 'center',
  color: '$overlay12',
  variants: {
    type: {
      sm: {
        size: '$4',
        fow: '600',
      },
      lg: {
        size: '$6',
        fow: '600',
      },
    },
  } as const,
})

const NoResultsCaption = styled(SizableText, {
  textAlign: 'center',
  color: '$overlay10',
  variants: {
    type: {
      sm: {
        size: '$2',
        fow: '500',
      },
      lg: {
        size: '$4',
        fow: '500',
      },
    },
  } as const,
})

export const NoResults = ({
  text,
  caption,
  icon = 'frown',
  size = 'lg',
  ...props
}: NoResultsProps & YStackProps) => {
  const Icon = iconMap[icon]
  return (
    <YStack gap="$3.5" jc="center" ai="center" py="$6" {...props}>
      <YStack br={1000} p="$2.5" jc="center" ai="center" bg="$white" {...shadowStandard}>
        <Icon color={colors.primary} width={36} height={36} />
      </YStack>
      <YStack gap="$2" ai="center" jc="center">
        <NoResultsText type={size}>{text}</NoResultsText>
        <NoResultsCaption type={size}>{caption}</NoResultsCaption>
      </YStack>
    </YStack>
  )
}
